<template>
<USlideover side="bottom" :prevent-close="!closable || backdropClose ">
  <div class="flex flex-col gap-0.5 pt-6 pb-1 px-4 relative" data-name="v3-popup">
    <div class="text-center" style="margin-top: -41px;" v-if="component === 'applyCoupon'">
        <img src="/public/v1/icons/Percentage-Green.png" alt="Apply Coupon" title="Apply Coupon" class="h-12 w-12 mx-auto" />
      </div>
    
    <!-- <div class="overflow-hidden mb-4 md:m"> -->
      <div
        v-if="(closable && isGiftForm) || isOrderFilter"
        class="flex justify-center w-full absolute -top-10 left-1/2 -translate-x-1/2"
      >
        <button
          type="button"
          class="flex items-center justify-center size-8 bg-white rounded-full border border-gray-200 shadow text-primary-500"
          aria-label="Close"
          @click="close"
        >
          <UIcon name="i-lucide-x" class="size-4" />
        </button>
      </div>
      <div class="overflow-y-auto max-h-screen flex flex-col">
        
      <div class="p-5 self-end py-3" v-if="closable && !isGiftForm && !isOrderFilter">
        <V3ImageComponent src="icons/close.png" class="h-4 w-4 cursor-pointer" @click="close"/>
      </div>
        
      <V3AddressPickerComponent v-if="component === 'address'" @success="$emit('success')" @close="close"/>
      <V3ReturnExpiredComponent :data="data" v-if="component === 'returnExpired'" @partialconfirm="$emit('partialconfirm')" @fullclose="$emit('fullclose')" @close="close"/>
      <V3AddressChangeComponent v-if="component === 'addresschange'" @success="$emit('success')" @close="close"/>
      <V3LocationChangeComponent v-if="component === 'locationchange'" @success="$emit('success')" @close="close"/>
      <V3CancelComponent :data="data" v-if="component === 'cancel'" @success="$emit('success')" @close="close"/>
      <V2ConfirmCancelComponent :data="data" v-if="component === 'confirmCancel'" @success="$emit('success')" @close="close"/>
      <V3LoginComponent v-if="component === 'login'" @success="$emit('success')" @close="close"/>
      <V3QuickMenuComponent v-if="component === 'quickmenu'" @close="close"/>
      <V2ReturnTrackerComponent :data="data" v-if="component === 'returnTracker'" @close="close"/>
      <V3ReplaceCartComponent :data="data" @close="close" @success="success" v-if="component === 'addcart'"/>
      <V3ErrorComponent :data="data" v-if="component === 'error'" @close="close"/>
      <V3LocationPickerComponent :data="data" v-if="component === 'location'" @close="close" @success="$emit('success')" />
      <V3ProviderInfoComponent :data="data" v-if="component === 'provider'" @close="close" />
      <V3ProviderLocationComponent :data="data" v-if="component === 'providerLocation'" @close="close" />
      <V3ProviderLocationComponent2 :data="data" v-if="component === 'providerLocation2'" @close="close" />
      <V3MyOrdersFilterComponent :data="data" v-if="component === 'MyorderFilter'" @close="close"  @success="orderFilter" />
      <V3MyGiftCardsFilterComponent :data="data" v-if="component === 'MyGiftCardFilter'" @close="close" @success="giftFilter"  />
      <V3TicketFormComponent :data="data" v-if="component === 'ticket'" @close="close" />
      <V3AddressFormComponent :data="data" v-if="component === 'addressPicker'" @dirty="dirty" @success="addressEvent" />
      <V3ServiceabilityErrorComponent :data="data" v-if="component === 'noservice'" @close="close" />
      <V3CustomizationComponent :data="data" v-if="component === 'customization'" @close="close" />
      <V3ChargesDetailComponent :data="data" v-if="component === 'charges'" @close="close" />
      <V3VariantsComponent :data="data" v-if="component === 'variants'" @close="close" />
      <V3CouponListComponent v-if="component === 'coupons'" :data="data" @apply="applyCoupon" @close="close" />
      <V3ContactUsComponent v-if="component === 'contactUS'" @close="close" />
      <V3TermsAndConditionComponent v-if="component === 'terms&conditions'" :data="data" @close="close" />
      <V3StoreClosedComponent :data="data" v-if="component === 'storeClosed'" @close="close" />
      <V3GiftCardReplaceComponent v-if="component === 'replace'" @close="close"  @success="$emit('success')" />
      <V2SenderDetailFormComponent v-if="component === 'sender'" :data="data" @close="close"   @success="(giftItemData) => $emit('success', giftItemData)"/>
      <V2ReceiverDetailFormComponent v-if="component === 'receiver'" :data="data" @close="close"   @success="(giftItemData) => $emit('success', giftItemData)"/>
      <V3IssuepopupComponent :data="data" v-if="component === 'issue'"/>
      <V3CouponApplyComponent v-if="component === 'applyCoupon'" :data="data" @apply="applyCoupon" @close="close" />
      <V3CouponTCComponent v-if="component === 'couponTC'" :data="data"@apply="applyCoupon" @close="close" />
      <V3AddToExistingComponent v-if="component === 'append'" :data="data" @close="close"   @success="$emit('success')" @add="$emit('add')"  />

      <V3RatingComponent v-if="component === 'rating'" :data="data" @close="close"  @success="$emit('success')"/>
      <V3RatingFormComponent v-if="component === 'ratingForm'" :data="data" @close="close"  @success="$emit('success')"/>
      <V3IoclOtpComponent v-if="component === 'iocl_otp'" @success="$emit('success')" @close="close"/>
      
    </div>
  </div>
</USlideover>
</template>

<script setup>
import { computed } from 'vue';
import V2SenderDetailFormComponent from "~/components/v2/SenderDetailFormComponent.vue";
import V2ReceiverDetailFormComponent from "~/components/v2/ReceiverDetailFormComponent.vue";

const props = defineProps({
  component: { type: String, required: true },
  closable: { type: Boolean, default: true },
  fullscreen: { type: Boolean, default: false },
  data: { type: Object },
  backdropClose: { type: Boolean, default: false },

})
const emit = defineEmits(['success', 'close', 'apply', 'dirty', 'partialconfirm', 'fullclose']);
const isGiftForm = computed(() => ['sender', 'receiver'].includes(props.component));
const isOrderFilter = computed(() => props.component === 'MyorderFilter');

const close = () => {
  if (props.component === 'issue') {
    window.history.back();
  } else {
    emit('close');
  }
};
const success = () => emit('success');
const applyCoupon = (couponCode) => {
  emit('apply', couponCode); 
  emit('close');
}
const addressEvent = (address) => {
  emit('success', address);
}
const orderFilter = (filter) => {
  emit('success', filter);
}

const dirty = (data) => {
  emit('dirty', data);
  console.log("dirty event emitted in popup component: ", data);
}
</script>